import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "place/spot-specification"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getSpotSpecificationsByTypeEnvironment(typeEnvironmentId) {

        if (typeEnvironmentId > 0) {

            let params = new URLSearchParams()
            params.set("grouped", "true")
            params.set("typeEnvironmentId", typeEnvironmentId)
            return http.list(path + "/getAllByTypeEnvironmentId",params);

        }
    }


}

export default new service();

